import React, { useMemo } from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Link from '../../../../../elements/Link';
import NotificationsBubble from '../../../../../elements/NotificationsBubble';
import Icon from '../../../../../elements/icons/Icon';
import { unreadFilter, useMergedNotifications } from '../../../../EventNotifications/useMergedNotifications';
import styles from '../EventIcons.module.scss';

const News = (props) => {
    const { event } = props,
        i18n = useI18n(),
        notifications = useMergedNotifications(event.id),
        unreadNotifications = useMemo(() => notifications.filter(unreadFilter), [notifications]);

    if (!notifications.length) return null;

    return (
        <Link className={styles.icon} href={['/events', event.id, 'notifications'].join('/')}>
            <Icon className={'news'} src="/img/event_news.png" color={event.settings.secondary_color}>
                <NotificationsBubble>{unreadNotifications.length}</NotificationsBubble>
            </Icon>
            <div>{i18n['label.Notifications']}</div>
        </Link>
    );
};

export default News;
